<template>
<div class="chapter">
<div class="inner_page">
<div class="MAIN_PAGE" id="d5e1498">
<p class="ct"><b>CONTENTS</b></p>
<p class="toc" id="c01"><a href="#/chapter1#c1">1 The Grace Abounding</a></p>
<p class="toc" id="c02"><a href="#/chapter2#c2">2 Spanish Cay</a></p>
<p class="toc" id="c03"><span href="#/chapter3#c3" title="Link target outside of Sample">3 Dark Waters</span></p>
<p class="toc" id="c04"><span href="#/chapter4#c4" title="Link target outside of Sample">4 A Man Called Garcia</span></p>
<p class="toc" id="c05"><span href="#/chapter5#c5" title="Link target outside of Sample">5 Whistle Up the Duppies</span></p>
<p class="toc" id="c06"><span href="#/chapter6#c6" title="Link target outside of Sample">6 The Man from CIA</span></p>
<p class="toc" id="c07"><span href="#/chapter7#c7" title="Link target outside of Sample">7 Beware of Greeks</span></p>
<p class="toc" id="c08"><span href="#/chapter8#c8" title="Link target outside of Sample">8 The Cretan Lover</span></p>
<p class="toc" id="c09"><span href="#/chapter9#c9" title="Link target outside of Sample">9 South from Andros</span></p>
<p class="toc" id="c010"><span href="#/chapter10#c10" title="Link target outside of Sample">10 Isle of Tears</span></p>
<p class="toc" id="c011"><span href="#/chapter11#c11" title="Link target outside of Sample">11 The Man in the Vaults</span></p>
<p class="toc" id="c012"><span href="#/chapter12#c12" title="Link target outside of Sample">12 Enter Comrade Orlov</span></p>
<p class="toc" id="c013"><span href="#/chapter13#c13" title="Link target outside of Sample">13 From the Jaws of the Tyrant</span></p>
<p class="toc" id="c014"><span href="#/chapter14#c14" title="Link target outside of Sample">14 Exuma Sound</span></p>
<p class="toc" id="c015"><span href="#/chapter15#c15" title="Link target outside of Sample">15 At the Caravel</span></p>
<p class="toc" id="c016"><span href="#/chapter16#c16" title="Link target outside of Sample">16 Greek Fire</span></p>
<p class="toc" id="c017"><span href="#/chapter17#c17" title="Link target outside of Sample">17 The Green Light</span></p>
<p class="toc" id="c018"><span href="#/chapter18#c18" title="Link target outside of Sample">18 The Purpose of Terrorism is to Terrorize</span></p>
<p class="toc" id="c019"><span href="#/chapter19#c19" title="Link target outside of Sample">19 The Stern Sea Chase</span></p>
<p class="toc" id="c020"><span href="#/chapter20#c20" title="Link target outside of Sample">20 Into an Indigo Dusk</span></p>
<p class="toc" id="c021"><span href="#/chapter21#c21" title="Link target outside of Sample">21 All Passion Spent</span></p>
<p class="toc" id="toc_bio"><span href="#/bio#bio01" title="Link target outside of Sample">A Biography of Jack Higgins</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?8a0d8bde